<template>
    <div>
        <v-snackbar 
            color="primary"
            v-model="user.switchedOrganisation">
            Organisatie succesvol gewijzigd naar {{user.organisation.name}}
            <v-btn
                color="primary"
                text
                @click="user.switchedOrganisation = false">
                <v-icon small color="white" >mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        
        <v-snackbar 
            color="error"
            v-model="user.switchedOrganisationError">
            Fout tijdens wisselen van organisatie.
            <v-btn
                text
                @click="user.switchedOrganisationError = false">
                <v-icon small color="white">mdi-close</v-icon>
            </v-btn>
        </v-snackbar>

    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user"])
  }
};
</script>
